// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Testimonials_testimonials__slideBox__AcH0V {
  max-width: 100vw;
  background-color: var(--color-primary-3);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  padding: 5rem 5rem;
  overflow: hidden;
}
.Testimonials_testimonials__slide__qBVGN {
  position: relative;
}
.Testimonials_testimonials__slide__qBVGN::before {
  content: "“";
  color: var(--color-primary);
  font-size: 8rem;
  line-height: 0;
  position: absolute;
  top: 50px;
}
.Testimonials_testimonials__slide__qBVGN::after {
  content: "”";
  color: var(--color-primary);
  font-size: 8rem;
  line-height: 0;
  position: absolute;
  right: 0;
  bottom: 20px;
}
.Testimonials_testimonials__slide_crumbBox__dYjgd {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.Testimonials_testimonials__slide_crumb__58pwy {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background-color: var(--color-primary);
  border-radius: 50%;
  cursor: pointer;
}
.Testimonials_testimonials__slide_content__ECVjQ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  padding: 10rem 3rem;
  backface-visibility: hidden;
  position: relative;
}
@media only screen and (max-width: 43.75em) {
  .Testimonials_testimonials__slide_content__ECVjQ {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.Testimonials_testimonials__slide_prev__NLq5t, .Testimonials_testimonials__slide_next__8z\\+Jt {
  color: #3B7EE3;
  font-size: 7rem;
  position: absolute;
  cursor: pointer;
  opacity: 0.3;
}
.Testimonials_testimonials__slide_prev__NLq5t:hover, .Testimonials_testimonials__slide_next__8z\\+Jt:hover {
  opacity: 1;
}
.Testimonials_testimonials__slide_prev__NLq5t {
  left: 0;
}
@media only screen and (max-width: 31.25em) {
  .Testimonials_testimonials__slide_prev__NLq5t {
    left: -30px;
  }
}
.Testimonials_testimonials__slide_next__8z\\+Jt {
  right: 0;
}
@media only screen and (max-width: 31.25em) {
  .Testimonials_testimonials__slide_next__8z\\+Jt {
    right: -30px;
  }
}
.Testimonials_testimonials__slide_main__BDFxK {
  display: grid;
  grid-template-columns: 42% 1fr;
  column-gap: 2rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .Testimonials_testimonials__slide_main__BDFxK {
    grid-template-columns: 100%;
    row-gap: 2rem;
    column-gap: 0;
    justify-items: center;
  }
}
.Testimonials_testimonials__slide_img__MsVjI {
  position: relative;
  margin-left: 3rem;
}
@media only screen and (max-width: 50em) {
  .Testimonials_testimonials__slide_img__MsVjI {
    left: -5rem;
    margin-bottom: 3rem;
  }
}
.Testimonials_testimonials__slide_img_shape__A8RU- {
  background-color: var(--color-primary);
  position: absolute;
  top: -4rem;
  left: 4rem;
  height: 47rem;
  width: 47rem;
  clip-path: polygon(0 27%, 32% 0, 100% 100%, 48% 100%);
  border-radius: 3px;
}
@media only screen and (max-width: 62.5em) {
  .Testimonials_testimonials__slide_img_shape__A8RU- {
    height: 35rem;
    width: 35rem;
    top: -3.5rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Testimonials_testimonials__slide_img_shape__A8RU- {
    height: 31rem;
    width: 31rem;
    top: -4rem;
  }
}
@media only screen and (max-width: 25em) {
  .Testimonials_testimonials__slide_img_shape__A8RU- {
    top: -5rem;
  }
}
.Testimonials_testimonials__slide_img_main__RLyIs {
  aspect-ratio: 1/1;
  width: 40rem;
  object-fit: cover;
  object-position: center center;
  position: relative;
  left: 3rem;
  z-index: 1;
}
@media only screen and (max-width: 62.5em) {
  .Testimonials_testimonials__slide_img_main__RLyIs {
    width: 30rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Testimonials_testimonials__slide_img_main__RLyIs {
    width: 25rem;
  }
}
.Testimonials_testimonials__slide_texts__EQrQX {
  margin-right: 3rem;
}
@media only screen and (max-width: 50em) {
  .Testimonials_testimonials__slide_texts__EQrQX {
    margin-right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Testimonials_testimonials__slide_texts_desc__Ua\\+Tg {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .Testimonials_testimonials__slide_texts_desc__Ua\\+Tg {
    text-align: center;
    width: 80%;
  }
}
@media only screen and (max-width: 31.25em) {
  .Testimonials_testimonials__slide_texts_desc__Ua\\+Tg {
    text-align: center;
    width: 100%;
  }
}
.Testimonials_testimonials__slide_texts_name__K5zoc {
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  color: var(--color-primary);
}
.Testimonials_testimonials__slide_texts_business__5AIGS {
  font-size: var(--default-font-small);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Testimonials.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGd;EACE,gBAAA;EACA,wCAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAII;EACE,YAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAFN;AAKI;EACE,YAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAHN;AAMI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAJN;AAOI;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;AALN;AAQI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AANN;AAQM;EATF;IAUI,sBAAA;IACA,uBAAA;IACA,mBAAA;EALN;AACF;AAQI;EAEE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAPN;AASM;EACE,UAAA;AAPR;AAWI;EACE,OAAA;AATN;AAWM;EAHF;IAII,WAAA;EARN;AACF;AAWI;EACE,QAAA;AATN;AAWM;EAHF;IAII,YAAA;EARN;AACF;AAWI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AATN;AAWM;EANF;IAOI,2BAAA;IACA,aAAA;IACA,aAAA;IACA,qBAAA;EARN;AACF;AAWI;EACE,kBAAA;EACA,iBAAA;AATN;AAUM;EAHF;IAII,WAAA;IACA,mBAAA;EAPN;AACF;AASM;EACE,sCAAA;EACJ,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACI,qDAAA;EAEA,kBAAA;AARR;AAUQ;EAXF;IAYI,aAAA;IACA,YAAA;IACA,YAAA;EAPR;AACF;AASQ;EAjBF;IAkBI,aAAA;IACA,YAAA;IACA,UAAA;EANR;AACF;AAQQ;EAvBF;IAwBI,UAAA;EALR;AACF;AAQM;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACJ,UAAA;AANJ;AAQQ;EATF;IAUI,YAAA;EALR;AACF;AAOQ;EAbF;IAcI,YAAA;EAJR;AACF;AAQI;EACE,kBAAA;AANN;AAQM;EAHF;IAII,eAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;EALN;AACF;AAOM;EACE,mBAAA;AALR;AAOQ;EAHF;IAII,kBAAA;IACA,UAAA;EAJR;AACF;AAMQ;EARF;IASI,kBAAA;IACA,WAAA;EAHR;AACF;AAMM;EACE,uCAAA;EACJ,gBAAA;EACA,2BAAA;AAJJ;AAOM;EACE,oCAAA;AALR","sourcesContent":["@import '../variables/breakpoints';\n\n.testimonials {\n  &__slideBox {\n    max-width: 100vw;\n    background-color: var(--color-primary-3);\n    background-image: url('../../img/background.png');\n    background-size: cover;\n    background-position: center;\n    padding: 5rem 5rem;\n    overflow: hidden;\n  }\n\n  &__slide {\n    position: relative;\n\n    &::before {\n      content: '\\201C';\n      color: var(--color-primary);\n      font-size: 8rem;\n      line-height: 0;\n      position: absolute;\n      top: 50px;\n    }\n  \n    &::after {\n      content: '\\201D';\n      color: var(--color-primary);\n      font-size: 8rem;\n      line-height: 0;\n      position: absolute;\n      right: 0;\n      bottom: 20px;\n    }\n\n    &_crumbBox {\n      display: flex;\n      justify-content: center;\n      gap: 1rem;\n    }\n\n    &_crumb {\n      display: inline-block;\n      width: 1.5rem;\n      height: 1.5rem;\n      background-color: var(--color-primary);\n      border-radius: 50%;\n      cursor: pointer;\n    }\n\n    &_content {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 3rem;\n      padding: 10rem 3rem;\n      backface-visibility: hidden;\n      position: relative;\n\n      @media only screen and (max-width: $bp-700) {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    &_prev,\n    &_next {\n      color: #3B7EE3;\n      font-size: 7rem;\n      position: absolute;\n      cursor: pointer;\n      opacity: .3;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n\n    &_prev {\n      left: 0;\n\n      @media only screen and (max-width: $bp-500) {\n        left: -30px;\n      }\n    }\n\n    &_next {\n      right: 0;\n\n      @media only screen and (max-width: $bp-500) {\n        right: -30px;\n      }\n    }\n\n    &_main {\n      display: grid;\n      grid-template-columns: 42% 1fr; \n      column-gap: 2rem;\n      align-items: center;\n\n      @media only screen and (max-width: $bp-800) {\n        grid-template-columns: 100%;\n        row-gap: 2rem;\n        column-gap: 0;\n        justify-items: center;\n      }\n    }\n\n    &_img {\n      position: relative;\n      margin-left: 3rem;\n      @media only screen and (max-width: $bp-800) {\n        left: -5rem;\n        margin-bottom: 3rem;\n      }\n\n      &_shape {\n        background-color: var(--color-primary);\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -4rem;\n\t\t\t\tleft: 4rem;\n\t\t\t\theight: 47rem;\n\t\t\t\twidth: 47rem;\n        clip-path: polygon(0 27%, 32% 0, 100% 100%, 48% 100%);\n        // clip-path: polygon(0% 20%, 32% 0, 100% 100%, 55% 100%);\n        border-radius: 3px;\n\n        @media only screen and (max-width: $bp-1000) {\n          height: 35rem;\n          width: 35rem;\n          top: -3.5rem;\n        }\n\n        @media only screen and (max-width: $bp-500) {\n          height: 31rem;\n          width: 31rem;\n          top: -4rem;\n        }\n\n        @media only screen and (max-width: $bp-400) {\n          top: -5rem;\n        }\n      }\n\n      &_main {\n        aspect-ratio: 1/1;\n        width: 40rem;\n        object-fit: cover;\n        object-position: center center;\n        position: relative;\n        left: 3rem;\n\t\t\t\tz-index: 1;\n\n        @media only screen and (max-width: $bp-1000) {\n          width: 30rem;\n        }\n\n        @media only screen and (max-width: $bp-500) {\n          width: 25rem;\n        }\n      }\n    }\n\n    &_texts {\n      margin-right: 3rem;\n      \n      @media only screen and (max-width: $bp-800) {\n        margin-right: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n      }\n\n      &_desc {\n        margin-bottom: 2rem;\n\n        @media only screen and (max-width: $bp-800) {\n          text-align: center;\n          width: 80%;\n        }\n\n        @media only screen and (max-width: $bp-500) {\n          text-align: center;\n          width: 100%;\n        }\n      }\n\n      &_name {\n        font-size: var(--default-font-subtitle);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n      }\n\n      &_business {\n        font-size: var(--default-font-small);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"testimonials__slideBox": `Testimonials_testimonials__slideBox__AcH0V`,
	"testimonials__slide": `Testimonials_testimonials__slide__qBVGN`,
	"testimonials__slide_crumbBox": `Testimonials_testimonials__slide_crumbBox__dYjgd`,
	"testimonials__slide_crumb": `Testimonials_testimonials__slide_crumb__58pwy`,
	"testimonials__slide_content": `Testimonials_testimonials__slide_content__ECVjQ`,
	"testimonials__slide_prev": `Testimonials_testimonials__slide_prev__NLq5t`,
	"testimonials__slide_next": `Testimonials_testimonials__slide_next__8z+Jt`,
	"testimonials__slide_main": `Testimonials_testimonials__slide_main__BDFxK`,
	"testimonials__slide_img": `Testimonials_testimonials__slide_img__MsVjI`,
	"testimonials__slide_img_shape": `Testimonials_testimonials__slide_img_shape__A8RU-`,
	"testimonials__slide_img_main": `Testimonials_testimonials__slide_img_main__RLyIs`,
	"testimonials__slide_texts": `Testimonials_testimonials__slide_texts__EQrQX`,
	"testimonials__slide_texts_desc": `Testimonials_testimonials__slide_texts_desc__Ua+Tg`,
	"testimonials__slide_texts_name": `Testimonials_testimonials__slide_texts_name__K5zoc`,
	"testimonials__slide_texts_business": `Testimonials_testimonials__slide_texts_business__5AIGS`
};
export default ___CSS_LOADER_EXPORT___;
